import { useState } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Header from "@/components/Header";
import HeroSection from "@/components/HeroSection";
import AnimatedDemo from "@/components/AnimatedDemo";
import FeaturesSection from "@/components/FeaturesSection";
import PricingSection from "@/components/PricingSection";
import LivePreview from "@/components/LivePreview";
import Documentation from "@/components/Documentation";
import FAQSection from "@/components/FAQSection";
import Footer from "@/components/Footer";
import ConfigWizard from "@/components/ConfigWizard";
import CheckoutModal from "@/components/CheckoutModal";
import AdminDashboard from "@/components/AdminDashboard";
import RefundPolicy from "@/components/RefundPolicy";
import CustomerPortal from "@/components/CustomerPortal";
import ContactForm from "@/components/ContactForm";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

function LandingPage() {
  const [wizardOpen, setWizardOpen] = useState(false);
  const [wizardVersion, setWizardVersion] = useState("free");
  const [checkoutOpen, setCheckoutOpen] = useState(false);
  const [checkoutPlan, setCheckoutPlan] = useState("starter");

  const openWizard = (version = "free") => {
    setWizardVersion(version);
    setWizardOpen(true);
  };

  const openCheckout = (planId) => {
    setCheckoutPlan(planId);
    setCheckoutOpen(true);
  };

  const handlePaymentSuccess = () => {
    setTimeout(() => {
      setCheckoutOpen(false);
      openWizard("pro");
    }, 500);
  };

  return (
    <div className="min-h-screen bg-white" data-testid="landing-page">
      <Header apiUrl={API} onDownload={() => openCheckout("business")} />
      <main>
        <HeroSection apiUrl={API} onDownload={() => openCheckout("business")} />
        <AnimatedDemo />
        <FeaturesSection />
        <PricingSection onDownload={openWizard} onBuyPro={openCheckout} />
        <LivePreview />
        <Documentation />
        <FAQSection />
      </main>
      <Footer apiUrl={API} onDownload={() => openCheckout("business")} />
      <ConfigWizard open={wizardOpen} onOpenChange={setWizardOpen} apiUrl={API} initialVersion={wizardVersion} />
      <CheckoutModal
        open={checkoutOpen}
        onOpenChange={setCheckoutOpen}
        planId={checkoutPlan}
        apiUrl={API}
        onSuccess={handlePaymentSuccess}
      />
    </div>
  );
}

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<LandingPage />} />
        <Route path="/admin" element={<AdminDashboard />} />
        <Route path="/refund-policy" element={<RefundPolicy />} />
        <Route path="/portal" element={<CustomerPortal />} />
        <Route path="/contact" element={<ContactForm />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
